import { useQuery } from "@tanstack/react-query";
import type { AccessoryTargetPrice } from "../types/accessoriesPricing";
import { getAccessoriesPrices } from "../services/accessoriesPricingService";

export const ACCESSORIES_PRICES_QUERY_KEY = "accessoriesPrices";

interface UseAccessoriesPricesOptions {
	bundleId: string;
	targetProductIds: string[];
}

export function useAccessoriesPrices({
	bundleId,
	targetProductIds,
}: UseAccessoriesPricesOptions) {
	return useQuery<Record<string, AccessoryTargetPrice>, Error>({
		queryKey: [ACCESSORIES_PRICES_QUERY_KEY, bundleId, targetProductIds],
		queryFn: async () => {
			const response = await getAccessoriesPrices(bundleId, targetProductIds);
			return Object.fromEntries(
				response.targets.map((target) => [target.productId, target]),
			);
		},
		enabled: !!bundleId && targetProductIds.length > 0,
		staleTime: 1000 * 60 * 5,
		gcTime: 1000 * 60 * 10,
		retry: 1,
	});
}
